var _circle, _circle2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimelineFinished(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 17,
    stroke: "url(#timeline-finished_svg__paint0_linear_875:2949)",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 7.5,
    fill: "url(#timeline-finished_svg__paint1_linear_875:2949)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "timeline-finished_svg__paint0_linear_875:2949",
    x1: 2.5,
    y1: 14.338,
    x2: 35,
    y2: 14.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CB0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A5C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "timeline-finished_svg__paint1_linear_875:2949",
    x1: 12.014,
    y1: 16.813,
    x2: 25.189,
    y2: 16.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CB0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A5C9"
  })))));
}

var MemoSvgTimelineFinished = /*#__PURE__*/React.memo(SvgTimelineFinished);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzciIGhlaWdodD0iMzciIHZpZXdCb3g9IjAgMCAzNyAzNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTguNSIgY3k9IjE4LjUiIHI9IjE3IiBzdHJva2U9InVybCgjcGFpbnQwX2xpbmVhcl84NzU6Mjk0OSkiIHN0cm9rZS13aWR0aD0iMyIvPgo8Y2lyY2xlIGN4PSIxOC41IiBjeT0iMTguNSIgcj0iNy41IiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXJfODc1OjI5NDkpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfODc1OjI5NDkiIHgxPSIyLjUiIHkxPSIxNC4zMzc1IiB4Mj0iMzUiIHkyPSIxNC4zMzc1IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMxQ0IwQUIiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMzNBNUM5Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhcl84NzU6Mjk0OSIgeDE9IjEyLjAxMzUiIHkxPSIxNi44MTI1IiB4Mj0iMjUuMTg5MiIgeTI9IjE2LjgxMjUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzFDQjBBQiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMzM0E1QzkiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { MemoSvgTimelineFinished as ReactComponent };